import React from 'react';
import { Box, Flex } from '../Rebass';
import Heading from '../Heading';
import Text from '../Text';
import { SxStyleProp } from '../Rebass/types';

interface SectionHeadingProps {
  headline?: string;
  headlineLineTwo?: string;
  description?: string;
  alignment?: 'left' | 'center';
  direction?: 'row' | 'column';
  renderCta?: React.ReactNode;
  headlineSize?: string;
  styles?: {
    headline: SxStyleProp;
    description: SxStyleProp;
  };
}

const SectionHeading = ({
  headline,
  headlineLineTwo,
  description,
  alignment,
  headlineSize, 
  renderCta,
  direction,
  styles,
}: SectionHeadingProps) => {
  const sectionHeadlineWidth = (alignment, direction) => {
    if (alignment === 'center') {
      return [1, 1, 6 / 12];
    } else {
      return [1];
    }
  };
  const sectionDescriptionWidth = (alignment, direction) => {
    if (alignment === 'center') {
      return [1, 1, 6 / 12];
    } else if (direction === 'column' && alignment !== 'center') {
      return [1, 1, 5 / 12];
    } else {
      return [1];
    }
  };

  return (
    <Flex
      pb={!description ? [4] : [6]}
      alignItems={alignment === 'center' ? 'center' : 'flex-start'}
      flexDirection={'column'}
    >
      {headline && (
        <Box
          className="sectionHeadline"
          width={sectionHeadlineWidth(alignment, direction)}
          sx={styles?.headline ?? {}}
        >
          <Heading as={headlineSize} size={headlineSize} textAlign={alignment} fontWeight="normal">
            <Box>{headline}</Box>
            {headlineLineTwo && <Box>{headlineLineTwo}</Box>}
          </Heading>
        </Box>
      )}
      {description && (
        <Box
          pt={[3]}
          width={sectionDescriptionWidth(alignment, direction)}
          sx={styles?.description ?? {}}
        >
          <Text textAlign={alignment} as={'p'} size="body">
            {description}
          </Text>
        </Box>
      )}
      {renderCta && <Box pt={[4]}>{renderCta}</Box>}
    </Flex>
  );
};

SectionHeading.defaultProps = {
  headline: '',
  headlineLineTwo: '',
  description: '',
  headlineSize: 'h2',
  alignment: 'left',
  direction: 'column',
  renderCta: null,
};

export default SectionHeading;
